import React from "react";
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "../ui/select";
import { formatDate } from "./constants";

export function MilestonesTab({ milestones, expanded, onUpdateStatus }) {
  return (
    <div className="space-y-3" data-testid="milestones-tab">
      <div className="flex justify-between items-center">
        <p className="text-sm text-slate-500">{milestones.length} milestone(s)</p>
        <div className="flex gap-2 text-[10px] text-slate-400">
          <span>{milestones.filter(m => m.status === "met" || m.status === "completed").length} met</span>
          <span>{milestones.filter(m => m.status === "missed" || m.status === "overdue").length} missed</span>
        </div>
      </div>
      {milestones.length === 0 ? (
        <p className="text-xs text-slate-400 text-center py-6">No milestones extracted yet. Use the Compliance page to extract milestones from this contract.</p>
      ) : (
        <div className={`space-y-2 overflow-y-auto ${expanded ? "max-h-[calc(100vh-350px)]" : "max-h-[400px]"}`}>
          {milestones.map((ms) => {
            const isOverdue = ms.due_date && new Date(ms.due_date) < new Date() && ms.status !== "met" && ms.status !== "completed";
            return (
              <div key={ms.id} className={`p-3 border rounded-sm ${isOverdue ? "border-red-200 bg-red-50/20" : ""}`}>
                <div className="flex items-center justify-between gap-2">
                  <div className="flex-1 min-w-0">
                    <p className="text-sm font-medium">{ms.title}</p>
                    <p className="text-xs text-slate-500 mt-0.5">{ms.description}</p>
                  </div>
                  <Select value={ms.status || "upcoming"} onValueChange={(v) => onUpdateStatus("milestones", ms.id, { status: v })}>
                    <SelectTrigger className="rounded-sm h-7 w-28 text-[10px]" data-testid={`ms-status-${ms.id}`}>
                      <SelectValue />
                    </SelectTrigger>
                    <SelectContent>
                      <SelectItem value="upcoming">Upcoming</SelectItem>
                      <SelectItem value="in_progress">In Progress</SelectItem>
                      <SelectItem value="met">Met</SelectItem>
                      <SelectItem value="missed">Missed</SelectItem>
                      <SelectItem value="overdue">Overdue</SelectItem>
                    </SelectContent>
                  </Select>
                </div>
                <div className="flex items-center gap-4 mt-1 text-[10px] text-slate-400">
                  {ms.due_date && <span>Due: {formatDate(ms.due_date)}</span>}
                  {ms.completed_at && <span>Completed: {formatDate(ms.completed_at)}</span>}
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
}
